<!-- eslint-disable -->
<template lang="pug">
    .finish-modal
        div
            .star-container(v-for="number in 300")
                star.star
        .finish-modal__searchlight
            .finish-modal__light.finish-modal__light--left
            .finish-modal__light.finish-modal__light--center
            .finish-modal__light.finish-modal__light--right
        .finish-modal__background
            .finish-modal__card
                .finish-modal__header {{ $i18n.t('olympiads.olympiads_finishModal_congratulations') }}
                img.finish-modal__turtle(:src="TURTLE_IN_CIRCLE")
                cs-button.finish-modal__button(@click="$router.push({name: 'dashboard'})", color="blue", pattern="primary")
                    | {{ $i18n.t('common.common_navigation_goToMain') }}
</template>

<script>
    /*eslint-disable*/
    import Star from '../../svg/Star.vue'
    import _ from 'lodash';
    import OlympiadApi from "../../../api/olympiad";
    import TURTLE_IN_CIRCLE from '../../../assets/images/olympiads/TurtleInCircle.svg';

    export default {
        data () {
            return {
                searchLightsInterval: null,
                starsAnimationInterval: null,
                TURTLE_IN_CIRCLE
            }
        },
        mounted () {
            this.loadSounds()
            .then(this.playSounds);
            this.startAnimation();
        },
        methods: {
            loadSounds () {
                return new Promise(resolve => {
                    let sound = OlympiadApi.getFinishSound();
                    this.$createjs.Sound.removeAllSounds();
                    this.$createjs.Sound.removeAllEventListeners();
                    this.$createjs.Sound.addEventListener('fileload', resolve);
                    this.$createjs.Sound.alternateExtensions = ["mp3"];
                    this.$createjs.Sound.registerSound(sound);
                });
            },
            playSounds () {
                this.$createjs.Sound.play("finishSound");
            },
            startAnimation () {
                this.animateStars();
            },
            changeStyle (style, to, scale, rotateDeg, opacity) {
                style.transform = style.transform === 'scale(0.5)' ?
                        `translate(${to.x}rem,${to.y}rem) scale(${scale}) rotate(${rotateDeg}deg)` : 'scale(0.5)';
                style.opacity = style.opacity === 1 ? opacity : 1;
            },
            starTransition (el) {
                let to = {
                    x: Math.random() * (_.random(0, 1) ? -20 : 20),
                    y: 0
                };
                let rotateDeg = _.random(0, 360);
                let scale = _.random(0, 0.7, true);
                let opacity = Math.random() + 0.5;
                let style = el.style;
                style.transform = 'scale(0.5)';
                style.display = 'block';
                style.transition = `2.5s`;

                this.$nextTick(() => {
                    this.changeStyle(style, to, scale, rotateDeg, opacity);
                });
                setInterval(() => {
                    this.changeStyle(style, to, scale, rotateDeg, opacity);
                }, _.random(2, 2.5, true)*1000);
            },
            animateStars () {
                let containers = document.querySelectorAll('.star-container');

                let width = window.innerWidth/2;
                let height = window.innerHeight/2;
                containers.forEach(el => {
                    let style = el.style;
                    style.display = 'block';
                    style.left = `${width}px`;
                    style.top = `${height}px`;

                    let max = width > height ? width : height;
                    let cords = {};
                    cords.x = Math.random()*max*(_.random(0, 1) ? 1 : -1);
                    cords.y = Math.random()*max*(_.random(0, 1) ? 1 : -1);
                    let translate =  cords.x + 'px,' + cords.y + 'px';
                    style.transform = 'translate(' + translate + ')';

                    this.starTransition(el.querySelector('.star'));
                });
            }
        },
        beforeDestroy () {
            this.$createjs.Sound.removeAllSounds();
            this.$createjs.Sound.removeAllEventListeners();
            clearInterval(this.starsAnimationInterval);
        },
        components: {
            Star
        }
    }
</script>

<style lang="scss" scoped>
    $color-green: #64a030;
    $color-light-green: #b4dc5a;
    $left-light-color: rgba(241, 201, 16, 1);
    $center-light-color: rgba(255, 255, 0, 1);
    $right-light-color: rgba(255, 255, 204, 1);

    @-webkit-keyframes left-rotation {
        0% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -30deg) translateY(-60px);
        }

        50% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, 10deg) translateY(-60px);
        }

        100% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -30deg) translateY(-60px);
        }
    }

    @keyframes left-rotation {
        0% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -30deg) translateY(-60px);
        }

        50% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, 10deg) translateY(-60px);
        }

        100% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -30deg) translateY(-60px);
        }
    }

    @-webkit-keyframes center-rotation {
        0% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -30deg) translateY(-60px);
        }

        50% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, 30deg) translateY(-60px);
        }

        100% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -30deg) translateY(-60px);
        }
    }

    @keyframes center-rotation {
        0% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -30deg) translateY(-60px);
        }

        50% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, 30deg) translateY(-60px);
        }

        100% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -30deg) translateY(-60px);
        }
    }

    @-webkit-keyframes right-rotation {
        0% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -30deg) translateY(-60px);
        }

        50% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, 30deg) translateY(-60px);
        }

        100% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -30deg) translateY(-60px);
        }
    }

    @keyframes right-rotation {
        0% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -10deg) translateY(-60px);
        }

        50% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, 30deg) translateY(-60px);
        }

        100% {
            transform-origin: top center;
            transform: rotate3d(0, 0, 1, -10deg) translateY(-60px);
        }
    }

    .star-container {
        position: fixed;
        pointer-events: none;
        will-change: transform;
    }
    .star {
        display: none;
    }

    .finish-modal {
        position: fixed;
        z-index: $z-index-modal;
        overflow: hidden;
        display: flex;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        background: url("../../../assets/images/olympiads/pattern.png"), linear-gradient(75deg, $color-green, $color-light-green);
        &__background {
            bottom: 0;
            left: 0;
            position: absolute;
            right: 0;
            top: 0;
            background-color: rgba(0, 0, 0, 0);
        }
        &__card {
            height: 100%;
            width: 100%;
            text-align: center;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-around;
            @include inset-space($space-small);
        }
        &__header {
            color: $x-color-white;
            flex: none;
            text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
            width: 100%;
            max-width: 250px;
            @include media($sm) {
                width: 60%;
                max-width: 350px;
                @include text($font-size-24);
            }
            @include media($md) {
                max-width: 650px;
                @include text($font-size-32);
            }
            @include media($lg) {
                width: 65%;
                @include text($font-size-44);
            }
        }
        &__turtle {
            max-width: 50%;
            max-height: 50%;
            @include media($sm) {
                max-width: 60%;
                max-height: 60%;
            }
            @include media($md) {
                max-width: 100%;
                max-height: 100%;
            }
        }
        &__button {
            display: block;
            @include text($font-size-24);
            background-color: $x-color-white;
            box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);
            color: $color-green-900;
            @include inset-squish-space($space-large);
        }
        &__searchlight {
            position: fixed;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            display: flex;
            justify-content: center;
        }
        &__light {
            transform-origin: top center;
            width: 30%;
            height: 100%;
            border-radius: $border-radius-circle $border-radius-circle 25% 25%;
            filter: blur(15px);
            min-width: 200px;
            @include media($sm) {
                min-width: 300px;
            }
            @include media($md) {
                min-width: 350px;
            }
            @include media($lg) {
                min-width: unset;
            }
            &--left {
                background: linear-gradient(to bottom, $left-light-color, rgba(0, 0, 0, 0));
                animation-name: left-rotation;
                animation-duration: 2s;
                animation-fill-mode: both;
                animation-iteration-count: infinite;
            }
            &--center {
                background: linear-gradient(to bottom, $center-light-color, rgba(0, 0, 0, 0));
                animation-name: center-rotation;
                animation-duration: 3s;
                animation-fill-mode: both;
                animation-iteration-count: infinite;
            }
            &--right {
                background: linear-gradient(to bottom, $right-light-color, rgba(0, 0, 0, 0));
                animation-name: right-rotation;
                animation-duration: 2.5s;
                animation-fill-mode: both;
                animation-iteration-count: infinite;
            }
        }
    }
</style>
